<template>
  <div>
    <vx-card class="mb-5">
      <vs-row vs-type="flex" vs-justify="space-between">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="3.5">
          <datepicker
            format="yyyy-MM-dd"
            v-model="startDate"
            placeholder="Start Date"
            class="w-full"
          ></datepicker>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="3.5">
          <datepicker
            format="yyyy-MM-dd"
            v-model="endDate"
            placeholder="End Date"
            class="w-full"
          ></datepicker>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="4">
          <vs-button
            color="success"
            type="border"
            :disabled="!dateIsSetted"
            @click="download"
            >Download</vs-button
          >
        </vs-col>
      </vs-row>
    </vx-card>

    <vx-card>
      <vs-table
        :sst="true"
        @search="handleSearch"
        max-items="10"
        search
        noDataText="لا يوجد بيانات"
        :data="data"
      >
        <template slot="header"> </template>

        <template slot="thead">
          <vs-th sort-key="name">Name</vs-th>
          <vs-th sort-key="name">Mobile</vs-th>
          <vs-th sort-key="name">Course Name</vs-th>
          <vs-th sort-key="name">Distributor</vs-th>
          <vs-th sort-key="name">Code</vs-th>
          <vs-th sort-key="name">Date</vs-th>
          <vs-th sort-key="name">Edit</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].id">
              {{ data[indextr].user.name }}
            </vs-td>
            <vs-td :data="data[indextr].id">
              {{ data[indextr].user.mobile_number }}
            </vs-td>
            <vs-td :data="data[indextr].id">
              {{ data[indextr].course.title }}
            </vs-td>
            <vs-td :data="data[indextr].id">
              {{ data[indextr].code.distributor.name }}
            </vs-td>
            <vs-td :data="data[indextr].id">
              {{ data[indextr].code.code }}
            </vs-td>
            <vs-td>
              {{ data[indextr].created_at | formatDate }}
            </vs-td>
            <vs-td>
              <feather-icon
                icon="EditIcon"
                svgClasses="w-5 h-5 hover:text-primary stroke-current"
                @click.stop="editData(indextr)"
              />
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <vs-pagination :total="totalPages" v-model="currentPage" class="mt-3" />
      <add-edit-form
        ref="addEditForm"
        :promptStatus="activePrompt"
        :oldDataObject="oldDataObject"
        @updateStatus="updateStatus($event)"
        @close="closeModel"
      >
      </add-edit-form>
    </vx-card>
  </div>
</template>

<script>
import addEditForm from "./form";
import Datepicker from "vuejs-datepicker";
import moment from "moment";

export default {
  components: { addEditForm, Datepicker },
  data: () => ({
    deleteItemId: -1,
    deletePrompt: false,
    activePrompt: false,
    data: [],
    search: "",
    page: 1,
    totalPages: 1,
    oldDataObject: {
      id: -1,
      name: "",
      username: "",
      mobile_number: "",
      service_id: ""
    },
    startDate: null,
    endDate: null
  }),
  mounted() {
    this.getData(this.page);
  },
  computed: {
    currentPage: {
      get() {
        return this.page;
      },
      set(val) {
        this.page = val;
        this.getData();
      }
    },
    dateIsSetted: function() {
      return this.startDate != null && this.endDate != null;
    }
  },
  methods: {
    async download() {
      this.$vs.loading();
      await axios({
        url:
          "/dashboard/export/students?startDate=" +
          moment(this.startDate).format("YYYY-MM-DD") +
          "&endDate=" +
          moment(this.endDate).format("YYYY-MM-DD"),
        method: "GET",
        responseType: "arraybuffer",
        headers: { "Content-Type": "application/x-www-form-urlencoded" }
      }).then(response => {
        var fileURL = window.URL.createObjectURL(
          new Blob([response.data], {
            type: "application/vnd.ms-excel"
          })
        );

        var fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute("download", "students.xlsx");
        document.body.appendChild(fileLink);

        fileLink.click();
      });
      this.$vs.loading.close();
    },
    async flipStatus(indextr) {
      this.$vs.loading();
      await axios
        .put("/dashboard/student/" + this.data[indextr].id + "/flip/")
        .then(res => {
          this.data[indextr].status = res.data.data.status;
        });
      this.$vs.loading.close();
    },
    addNewItem() {
      this.activePrompt = true;
    },
    editData(idx) {
      this.oldDataObject = Object.assign({}, this.data[idx].user);
      this.activePrompt = true;
    },
    openConfirm(id) {
      this.deleteItemId = id;
      this.deletePrompt = true;
    },
    updateStatus(event) {
      if (event.isNew === true) {
        this.data.push(event.data);
      } else {
        let roleIdx = this.data.findIndex(e => e.id === event.data.id);
        this.$set(this.data, roleIdx, event.data);
      }
      this.activePrompt = false;
    },
    closeModel() {
      this.activePrompt = false;
    },
    close() {
      this.deletePrompt = false;
    },
    async deleteRequest() {
      this.$vs.loading();
      await axios
        .delete("/city/" + this.data[this.deleteItemId].id)
        .then(res => {
          if (res.status === 200) {
            this.data.splice(this.deleteItemId, 1);
            this.$vs.notify({
              title: "تم الحذف بنجاح",
              text: "تم حذف المدينة بنجاح",
              color: "success",
              position: "top-left"
            });
          }
        });
      this.$vs.loading.close();
    },
    async getData() {
      this.$vs.loading();
      await axios
        .get(
          "/dashboard/student?page=" +
            this.page +
            (this.search != "" ? "&q=" + this.search : "")
        )
        .then(response => {
          this.data = response.data.data.data;
          this.totalPages = response.data.data.last_page;
        });
      this.$vs.loading.close();
    },
    handleSearch(searching) {
      this.search = searching;
      this.getData();
    }
  }
};
</script>
